export class UserModel {
  userId: number;
  firstName: string;
  secondName: string;
  email: string;
  gender: number;
  school: string;
  country: number;
  firstLanguage: number;
  displayLanguage: string;
  emailPreference: boolean;
  currentPassword: string;
  password: string;
  batchType: string;
  productId: string;
  daraUserId: number;
  hasSeenLatestPolicy: boolean;
}

export class UserAcademicLevel {
  gradeIndex: number;
}



// WEBPACK FOOTER //
// ./src/app/models/user/user.model.ts